import React, {useRef} from 'react';
import { SearchIcon } from "../../assets/icons/Icons"
import {useFilterContext} from '../../contexts/FilterContext';
import {useTranslation} from "react-i18next";

const SearchFilter = ({className, placeholderText, inputType, icon, hideIcon, inputStyles}) => {

    const { t } = useTranslation();

    const {name, filterValue, setFilterValue, updateURLParams } = useFilterContext();
    const input = useRef();
    const handleInputChange = (e) => {
        const value = e.target.value;
        setFilterValue(value);
        updateURLParams(name, value, 300);
    };

    return (
        <div className={`filter search-filter ${className}`}>
            <div className={hideIcon ? "" : "input-with-icon input-with-icon-left" }>
                {hideIcon ? '' : <div className="input-icon input-icon-left">{icon ? icon : <SearchIcon/>}</div>}
                <input ref={input} value={filterValue} type={inputType ? inputType : "text"} name={name} placeholder={placeholderText ? placeholderText : t("Search...")} onChange={handleInputChange} style={inputStyles}/>
            </div>
        </div>
    );
};

export default SearchFilter;
